import { makeStyles } from "@fluentui/react-components";

export const useClauseCardStyles = makeStyles({
  clauseCardContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "5px",
    width: "100%",
  },
  clauseCard: {
    ":hover": {
      backgroundColor: "transparent",
    },
  },
  clauseAccepted: {
    backgroundColor: "rgba(30, 168, 44, 0.1)",
    ":hover": {
      backgroundColor: "rgba(30, 168, 44, 0.1)",
    },
  },
  clauseEndorsed: {
    border: "1px solid #33CCCC",
  },
  clauseDeclined: {
    backgroundColor: "rgba(164, 12, 12, 0.1)",
  },
  clauseCardContentWrapper: {
    display: "flex",
    flexDirection: "row",
    columnGap: "12px",
  },
  clauseCardSideActionContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "5px",
  },
  clauseTextContainer: {
    overflow: "hidden",
    whiteSpace: "normal",
    textOverflow: "ellipsis",
    cursor: "text",
    userSelect: "text",
    "&::selection": {
      backgroundColor: "#242424",
      color: "#fff",
    },
  },
  clauseTextReader: {
    WebkitLineClamp: 7,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  clauseTextExpanded: {
    WebkitLineClamp: 20,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflowY: "auto",
    overflowX: "hidden",
  },
});
